<template>
  <ListEditor
    :buttonText="buttonText"
    :class="'dynamic-controls-double-list-box'"
    :component="dynamicComponent"
    :disableAddListItem="disableAddListItem"
    :dropdownLabel="labels.dropdown"
    :handleAddListItem="handleAddAttribute"
    :handleChangeListItem="handleChangeListItem"
    :handleItemToggleChange="control.handleItemToggleChange"
    :handleRemoveListItem="handleRemoveAttribute"
    :headerText="control.label"
    :inputLabel="labels.input"
    :listItems="value"
    :listName="control.listName"
    :namePlaceholder="control.namePlaceholder"
    :nameValidation="control.nameValidation"
    :tooltip="getTooltip()"
    :valuePlaceholder="control.valuePlaceholder"
    :valueValidation="control.valueValidation"
  />
</template>
<script>
import { cloneDeep } from 'lodash';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import ListEditor from 'client/components/FormValidation/ListEditor';

export default {
  name: 'DynamicControlsDoubleListBox',

  components: {
    ListEditor,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  inject: ['$validator'],

  props: {
    value: {
      default: () => [],
      type: Array,
    },
  },

  data() {
    return {
      addingValue: false,
    };
  },

  computed: {
    // policy templates use displayOptions to dynamically populate options based on displayType
    buttonText(state) {
      const { buttonText, displayOptions } = state.control;
      const defaultText = 'add new custom attribute';

      return (displayOptions && displayOptions.buttonText) || buttonText || defaultText;
    },
    /**
     * Disable the add button when adding a new attribute until the new
     * attribute has both a name and a value, or it is removed.
     */
    disableAddListItem() {
      const { name, value } = (this.value && this.value[0]) || {};

      if (this.addingValue && (!name || !value)) {
        return true;
      }

      return false;
    },
    /**
     * Return dynamic attribute component, otherwise,
     * it uses the default generic component.
     */
    dynamicComponent() {
      return this.control.component || 'CustomAttributeFields';
    },

    // specific labels, otherwise empty string
    labels() {
      switch (this.dynamicComponent) {
        case 'DatabaseAttributeFields':
          return { input: 'Service Provider Attribute Name', dropdown: 'JumpCloud Attribute Name' };
        case 'CustomAttributeFields':
          return { input: 'Service Provider Attribute Name', dropdown: 'Value' };
        default:
          return { input: '', dropdown: '' };
      }
    },
  },

  methods: {
    addAttribute() {
      const clonedValues = cloneDeep(this.value);
      const attribute = {
        tempId: String(Date.now()),
        name: '',
        value: '',
      };

      clonedValues.splice(0, 0, attribute);
      this.handleValueChange(this.control.id, clonedValues);
      this.addingValue = true;
    },

    changeListItem({ index, listItem, values }) {
      const clonedValues = cloneDeep(values);
      clonedValues[index] = { ...clonedValues[index], ...listItem };
      this.handleValueChange(this.control.id, clonedValues);

      if (this.addingValue && index === 0 && !this.disableAddListItem) {
        this.addingValue = false;
      }
    },

    getListEditorChildren() {
      return this.$children[0].$children;
    },

    handleAddAttribute(event) {
      const handler = this.control.handleAddAttribute || this.addAttribute;
      handler(event);
    },

    handleChangeListItem(index, listItem, columnName) {
      const handler = this.control.handleChangeListItem || this.changeListItem;
      handler({
        index, listItem, values: this.value, columnName,
      });
    },

    handleRemoveAttribute(index) {
      const handler = this.control.handleRemoveAttribute || this.removeAttribute;
      handler(index);
    },

    removeAttribute(index) {
      const clonedValues = cloneDeep(this.value);
      clonedValues.splice(index, 1);

      this.handleValueChange(this.control.id, clonedValues);
      if (this.addingValue && index === 0) {
        this.addingValue = false;
      }
    },
  },
};
</script>
